import React from "react";
import WhatsappContact from "../../assets/svgs/WhatsappContact";
import { useSelector } from "react-redux";

const WhatsappButton: React.FC = ({ floatingWhatsappNumber }) => {
  const { bussinessData } = useSelector((state: any) => state.bussinessData);
  const openWhatsapp = () => {
    let phoneNumber = floatingWhatsappNumber;
    // Remove all non-digit characters (spaces, +, invisible unicode, etc.)
    phoneNumber = phoneNumber.replace(/\D/g, "");

    const message = encodeURIComponent(`Hello, 
I saw a product on your website that I'm interested in. 
Can you provide more details?`);

    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, "_blank");
  };
  // href="https://wa.me/+201203110365?text=welcome"
  return (
    <button
      // aria-label="Scroll to top"
      type="button"
      className="whats-contact-wrapper"
      onClick={openWhatsapp}
    >
      <WhatsappContact />
    </button>
  );
};

export default WhatsappButton;
